import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'cdw-ae-google-login-button',
  imports: [CommonModule],
  templateUrl: './google-login-button.component.html',
  styleUrl: './google-login-button.component.scss',
})
export class GoogleLoginButtonComponent {}
